import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SearchMemberAccountResponse } from '../models/search-member-account.response';
import { APP_CONFIG, APP_CONFIG_LOCAL } from 'src/app/core/services/app-config.service';
import { MemberInfoResponse } from '../models/member-info.response';
import { MemberInfoRequestBody } from '../models/member-info.request';
import { MemberSearchAccountRequestBody } from '../models/search-member-account.request';
import { MemberUpdateRequestBody } from '../models/member-account-update.request';
import { MemberSendNotificationRequestBody } from '../models/member-account-send-notification.request';
import { MemberAccountSendNotificationResponse } from '../models/member-account-send-notification.response';
import { BillingInfoRequestBody } from '../models/member-billing-info.request';
import { MemberDemographicResponse } from '../models/member-demographic.response';
import { MemberDemographicRequestBody } from '../models/member-demographic.request';
import { MemberBillingPrefrenceSaveRequest } from '../models/member-billing-prefrence-save.request';
import { MemberBillingPrefrenceResponse } from '../models/member-billing-prefrence.response';
import { MemberBillingPrefrenceRequest } from '../models/member-billing-prefrence.request';
import { MemberBillingPrefrenceSaveResponse } from '../models/member-billing-prefrence-save.response';
import { MemberSearchEpflowRequestBody } from '../models/search-member-epflow.request';
import { SearchMemberEpflowResponse } from '../models/search-member-epflow.response';

@Injectable({
  providedIn: 'root'
})
export class MemberSearchService {
  memberSearchResult!: SearchMemberAccountResponse;
  constructor(public httpClient: HttpClient) { }

  searchMemberAccount(requestBody: MemberSearchAccountRequestBody): Observable<SearchMemberAccountResponse> {
    if (window.location.hostname === 'localhost') {
      return this.httpClient.get<SearchMemberAccountResponse>(APP_CONFIG_LOCAL.LOCAL_MEMBER_SEARCH_ACCOUNT);
    } else {
      return this.httpClient.post<SearchMemberAccountResponse>(`${APP_CONFIG.API_BASE_URL}${APP_CONFIG.MEMBER_SEARCH_ACCOUNT}`, requestBody)
    }

  }

  updateMemberProfile(requestBody: MemberUpdateRequestBody): Observable<any> {
    if (window.location.hostname === 'localhost') {
      return this.httpClient.get<any>(APP_CONFIG_LOCAL.LOCAL_MEMBER_PROFILE_UPDATE);
    } else {
      return this.httpClient.post<any>(`${APP_CONFIG.API_BASE_URL}${APP_CONFIG.MEMBER_PROFILE_UPDATE}`, requestBody);
    }

  }

  fetchMemberInfo(requestBody: MemberInfoRequestBody): Observable<MemberInfoResponse> {
    if (window.location.hostname === 'localhost') {
      return this.httpClient.get<MemberInfoResponse>(APP_CONFIG_LOCAL.LOCAL_MEMBER_INFO);
    } else {
      return this.httpClient.post<MemberInfoResponse>(`${APP_CONFIG.API_BASE_URL}${APP_CONFIG.MEMBER_INFO}`, requestBody);
    }

  }

  sendMemberNotification(requestBody: MemberSendNotificationRequestBody): Observable<MemberAccountSendNotificationResponse> {
    if (window.location.hostname === 'localhost') {
      return this.httpClient.get<MemberAccountSendNotificationResponse>(APP_CONFIG_LOCAL.LOCAL_MEMBER_SEND_NOTIFICATION);
    } else {
      return this.httpClient.post<MemberAccountSendNotificationResponse>(`${APP_CONFIG.API_BASE_URL}${APP_CONFIG.MEMBER_SEND_NOTIFICATION}`, requestBody);
    }

  }

  getMemberDemographic(requestBody: MemberDemographicRequestBody): Observable<MemberDemographicResponse> {
    return this.httpClient.post<MemberDemographicResponse>(`${APP_CONFIG.API_BASE_URL}${APP_CONFIG.ELIGIBILITY_INFO_EP}`, requestBody);
  }
  getBillingInfo(requestBody: BillingInfoRequestBody): Observable<any> {
    return this.httpClient.post<any>(`${APP_CONFIG.API_BASE_URL}${APP_CONFIG.MEMBER_BILLING_INFO_EP}`, requestBody);
  }

  searchMemberBillingPrefrence(requestBody: MemberBillingPrefrenceRequest): Observable<MemberBillingPrefrenceResponse> {
    return this.httpClient.post<MemberBillingPrefrenceResponse>(`${APP_CONFIG.API_BASE_URL}${APP_CONFIG.SEARCH_MANAGE_BILLING_DEL_PREFRENCE}`, requestBody);
  }
  saveMemberBillingPrefrence(requestBody: MemberBillingPrefrenceSaveRequest): Observable<MemberBillingPrefrenceSaveResponse> {
    return this.httpClient.post<MemberBillingPrefrenceSaveResponse>(`${APP_CONFIG.API_BASE_URL}${APP_CONFIG.SAVE_MANAGE_BILLING_DEL_PREFRENCE}`, requestBody);
  }


  formatDateString(input: string | null) {
    if (input) {
      // Create new date object by parsing the input date string
      const month = Number(input.slice(4, 6));
      const day = Number(input.slice(6, 8));
      const year = Number(input.slice(0, 4));
      const hours = Number(input.slice(8, 10));
      const minutes = Number(input.slice(10, 12));
      const seconds = Number(input.slice(12, 14));
      const miliSeconds = Number(input.slice(14, 17));
      const date = new Date(Date.UTC(year, month, day, hours, minutes, seconds, miliSeconds))


      // Extract the month, add 1 (because months are zero based), and add pad with leading zero if needed
      const m = month.toString().padStart(2, '0');

      // Extract the day, and add pad with leading zero if needed
      const d = day.toString().padStart(2, '0');

      // Extract the year
      const y = date.getFullYear();

      // return the date in 'MM/dd/yyyy' format
      return `${m}/${d}/${year}`;
    }
    return ' ';
  }

  /**
    * validate date format
    * If it is invalid return false otherwise return true
    */
  validateDateFormat(isDateKeyPress = false, dob: any) {
    const d = dob;
    const currentDate = new Date();
    if (!d) {
      if (isDateKeyPress) {
        return { 'success': false, 'invalidDate': true };
      }
      return { 'success': true };
    }
    if(d.length !== 10) {
      return { 'success': false, 'invalidDate': true };
    }
    const splitDate = d?.split("-");
    const month: any = parseInt(splitDate[0], 10);
    const day: any = parseInt(splitDate[1], 10);
    const year: any = parseInt(splitDate[2], 10);
    const userDate = new Date(month + "/" + day + "/" + year);
    if(userDate.toString() === 'Invalid Date') {
      return { 'success': false, 'invalidDate': true };
    }
    if (userDate > new Date(currentDate)) {
      return { 'success': false, 'futureDate': true };
    }
    return { 'success': true };
  }
searchMemberEpflow(requestBody: MemberSearchEpflowRequestBody): Observable<SearchMemberEpflowResponse> {
    if (window.location.hostname === 'localhost') {
      return this.httpClient.get<SearchMemberEpflowResponse>(APP_CONFIG_LOCAL.LOCAL_MEMBER_SEARCH_EPFLOW);
    } else {
      return this.httpClient.post<SearchMemberEpflowResponse>(`${APP_CONFIG.API_BASE_URL}${APP_CONFIG.MEMBER_SEARCH_EPFLOW}`, requestBody)
    }
}
}
